var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-nocheck
/* eslint-disable lines-around-comment */
import { withStyles } from "@mui/styles";
import React, { Component } from "react";
// @ts-ignore
import { moderatorService } from "../../../../../service";
// @ts-ignore
import { jitsiLocalStorage } from "lib-js-utils/jitsi-local-storage";
import { batch } from "react-redux";
// @ts-expect-error
import keyboardShortcut from "../../../../../modules/keyboardshortcut/keyboardshortcut";
import { isSpeakerStatsDisabled } from "../../../../features/speaker-stats/functions";
import { ACTION_SHORTCUT_TRIGGERED, createShortcutEvent, createToolbarEvent, } from "../../../analytics/AnalyticsEvents";
import { sendAnalytics } from "../../../analytics/functions";
// @ts-ignore
import { createInviteDialogEvent } from "../../../analytics";
import { getMultipleVideoSendingSupportFeatureFlag, getToolbarButtons, isToolbarButtonEnabled, } from "../../../base/config/functions.web";
import { openDialog, toggleDialog } from "../../../base/dialog/actions";
// @ts-ignore
import { AlertDialog } from "../../../base/dialog/index";
import { isIosMobileBrowser, isMobileBrowser, } from "../../../base/environment/utils";
import { translate } from "../../../base/i18n/functions";
import JitsiMeetJS from "../../../base/lib-jitsi-meet";
// @ts-ignore
import { PARTICIPANT_ROLE, kickParticipant,
// @ts-ignore
 } from "../../../base/participants";
import { raiseHand, } from "../../../base/participants/actions";
import { getLocalParticipant, hasRaisedHand, } from "../../../base/participants/functions";
import { connect } from "../../../base/redux/functions";
import { getLocalVideoTrack } from "../../../base/tracks/functions.any";
import AudioSettingsPopup from "../../../settings/components/web/audio/AudioSettingsPopup";
import { toggleChat } from "../../../chat/actions.web";
// @ts-ignore
import { ChatButton } from "../../../chat/components";
// @ts-ignore
import { EmbedMeetingButton } from "../../../embed-meeting";
// @ts-ignore
import { SharedDocumentButton } from "../../../etherpad";
// @ts-ignore
import { FeedbackButton } from "../../../feedback";
import { setGifMenuVisibility } from "../../../gifs/actions";
// @ts-ignore
import { isGifEnabled } from "../../../gifs/functions.web";
import { getInviteTypeCounts } from "../../../invite";
import { beginAddPeople, beginCallPrompt } from "../../../invite/actions.any";
// @ts-ignore
import { InviteButton } from "../../../invite/components/add-people-dialog";
// @ts-ignore
import { invite } from "../../../invite/actions.any";
import { isVpaasMeeting } from "../../../jaas/functions";
// @ts-ignore
import { KeyboardShortcutsButton } from "../../../keyboard-shortcuts";
import { NoiseSuppressionButton } from "../../../noise-suppression/components";
import { close as closeParticipantsPane, open as openParticipantsPane, } from "../../../participants-pane/actions.any";
// @ts-ignore
import { ParticipantsPaneButton } from "../../../participants-pane/components/web";
import { getParticipantsPaneOpen } from "../../../participants-pane/functions";
import { addReactionToBuffer } from "../../../reactions/actions.any";
import { toggleReactionsMenuVisibility } from "../../../reactions/actions.web";
import ReactionsMenuButton from "../../../reactions/components/web/ReactionsMenuButton";
import { REACTIONS } from "../../../reactions/constants";
// @ts-ignore
import { isReactionsEnabled } from "../../../reactions/functions.any";
import { LiveStreamButton, RecordButton,
// @ts-ignore
 } from "../../../recording/actions";
// @ts-ignore
import { NOTIFICATION_TIMEOUT, showNotification } from "../../../notifications";
import { isSalesforceEnabled } from "../../../salesforce/functions";
import { startScreenShareFlow } from "../../../screen-share/actions.web";
// @ts-ignore
import ShareAudioButton from "../../../screen-share/components/web/ShareAudioButton";
import { isScreenAudioSupported, isScreenVideoShared, } from "../../../screen-share/functions";
// @ts-ignore
import SecurityDialogButton from "../../../security/components/security-dialog/web/SecurityDialogButton";
// @ts-ignore
import { SettingsButton, toggleAudioSettings } from "../../../settings";
// @ts-ignore
import { SharedVideoButton } from "../../../shared-video/components";
// @ts-ignore
import { SpeakerStatsButton } from "../../../speaker-stats/components/web";
import SpeakerStats from "../../../speaker-stats/components/web/SpeakerStats";
import { ClosedCaptionButton,
// @ts-ignore
 } from "../../../subtitles";
import { TileViewButton, toggleTileView, shouldDisplayTileView, } from "../../../video-layout";
// @ts-ignore
import { VideoQualityButton, VideoQualityDialog, } from "../../../video-quality/components";
// @ts-ignore
import { VideoBackgroundButton } from "../../../virtual-background";
import WhiteboardButton from "../../../whiteboard/components/web/WhiteboardButton";
import { isWhiteboardButtonVisible } from "../../../whiteboard/functions";
import { setFullScreen, setHangupMenuVisible, setOverflowMenuVisible, setToolbarHovered, showToolbox, } from "../../actions.web";
import { NOTIFY_CLICK_MODE, NOT_APPLICABLE, THRESHOLDS } from "../../constants";
import { getToolbarAdditionalButtons, isDesktopShareButtonDisabled, isToolboxVisible, } from "../../functions";
import { getJwtDisabledButtons } from "../../functions.any";
// @ts-ignore
import DownloadButton from "../DownloadButton";
// @ts-ignore
import HangupButton from "../HangupButton";
// @ts-ignore
import HelpButton from "../HelpButton";
// @ts-ignore
import AudioSettingsButton from "./AudioSettingsButton";
// @ts-ignore
import FullscreenButton from "./FullscreenButton";
// @ts-ignore
import LinkToSalesforceButton from "./LinkToSalesforceButton";
// @ts-ignore
import ProfileButton from "./ProfileButton";
// @ts-ignore
import ShareDesktopButton from "./ShareDesktopButton";
// @ts-ignore
import ToggleCameraButton from "./ToggleCameraButton";
// @ts-ignore
import VideoSettingsButton from "./VideoSettingsButton";
import { ToolbarButton } from "../../../toolbox/components/web";
import { IconChat, IconInviteMore, IconPresentation, IconRaisedHand, IconConnect, IconAudio } from '../../../base/icons';
import { ChatCounter } from '../../../chat';
const styles = () => {
    return {
        contextMenu: {
            position: "relative",
            right: "auto",
            margin: 0,
            marginBottom: "8px",
            maxHeight: "80vh",
        },
        hangupMenu: {
            position: "relative",
            right: "auto",
            display: "flex",
            flexDirection: "column",
            rowGap: "8px",
            margin: 0,
            padding: "16px",
            marginBottom: "8px",
        },
    };
};
/**
 * Implements the conference toolbox on React/Web.
 *
 * @augments Component
 */
class Toolbox extends Component {
    /**
     * Initializes a new {@code Toolbox} instance.
     *
     * @param {IProps} props - The read-only React {@code Component} props with
     * which the new instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isShowConnect: true,
        };
        // Bind event handlers so they are only bound once per instance.
        this._onMouseOut = this._onMouseOut.bind(this);
        this._onMouseOver = this._onMouseOver.bind(this);
        this._onSetHangupVisible = this._onSetHangupVisible.bind(this);
        this._onSetOverflowVisible = this._onSetOverflowVisible.bind(this);
        this._onTabIn = this._onTabIn.bind(this);
        this._onShortcutToggleChat = this._onShortcutToggleChat.bind(this);
        this._onShortcutToggleFullScreen =
            this._onShortcutToggleFullScreen.bind(this);
        this._onShortcutToggleParticipantsPane =
            this._onShortcutToggleParticipantsPane.bind(this);
        this._onShortcutToggleRaiseHand =
            this._onShortcutToggleRaiseHand.bind(this);
        this._onShortcutToggleScreenshare =
            this._onShortcutToggleScreenshare.bind(this);
        this._onShortcutToggleVideoQuality =
            this._onShortcutToggleVideoQuality.bind(this);
        this._onToolbarToggleParticipantsPane =
            this._onToolbarToggleParticipantsPane.bind(this);
        this._onToolbarOpenVideoQuality =
            this._onToolbarOpenVideoQuality.bind(this);
        this._onToolbarToggleChat = this._onToolbarToggleChat.bind(this);
        this._onToolbarToggleFullScreen =
            this._onToolbarToggleFullScreen.bind(this);
        this._onToolbarToggleRaiseHand =
            this._onToolbarToggleRaiseHand.bind(this);
        this._onToolbarToggleScreenshare =
            this._onToolbarToggleScreenshare.bind(this);
        this._onShortcutToggleTileView =
            this._onShortcutToggleTileView.bind(this);
        this._onShortcutSpeakerStats = this._onShortcutSpeakerStats.bind(this);
        this._onEscKey = this._onEscKey.bind(this);
        this._onToolbarOpenInvite = this._onToolbarOpenInvite.bind(this);
        this._onOpenConnectCodec = this._onOpenConnectCodec.bind(this);
        this._onDisconnectCodec = this._onDisconnectCodec.bind(this);
        this.openAudioSetting = this.openAudioSetting.bind(this);
    }
    /**
     * Sets keyboard shortcuts for to trigger ToolbarButtons actions.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        const { _toolbarButtons, t, dispatch, _reactionsEnabled, _gifsEnabled, _isSpeakerStatsDisabled, conferencePar, } = this.props;
        let codecParticipant = [];
        const ipRegex = /(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/;
        if (conferencePar) {
            Object.keys(conferencePar).map(function (key, index) {
                var _a;
                if (key === 'remote') {
                    if (((_a = conferencePar[key]) === null || _a === void 0 ? void 0 : _a.size) > 0) {
                        //@ts-ignore
                        [...conferencePar[key].values()].forEach((x) => {
                            if ((x === null || x === void 0 ? void 0 : x.isJigasi) && ipRegex.test(x === null || x === void 0 ? void 0 : x.name))
                                codecParticipant.push(x);
                        });
                    }
                }
            });
        }
        if (codecParticipant.length > 0) {
            this.setState({
                isShowConnect: false,
            });
        }
        else {
            this.setState({
                isShowConnect: true,
            });
        }
        const KEYBOARD_SHORTCUTS = [
            isToolbarButtonEnabled("videoquality", _toolbarButtons) && {
                character: "A",
                exec: this._onShortcutToggleVideoQuality,
                helpDescription: "toolbar.callQuality",
            },
            isToolbarButtonEnabled("chat", _toolbarButtons) && {
                character: "C",
                exec: this._onShortcutToggleChat,
                helpDescription: "keyboardShortcuts.toggleChat",
            },
            isToolbarButtonEnabled("desktop", _toolbarButtons) && {
                character: "D",
                exec: this._onShortcutToggleScreenshare,
                helpDescription: "keyboardShortcuts.toggleScreensharing",
            },
            isToolbarButtonEnabled("participants-pane", _toolbarButtons) && {
                character: "P",
                exec: this._onShortcutToggleParticipantsPane,
                helpDescription: "keyboardShortcuts.toggleParticipantsPane",
            },
            isToolbarButtonEnabled("raisehand", _toolbarButtons) && {
                character: "R",
                exec: this._onShortcutToggleRaiseHand,
                helpDescription: "keyboardShortcuts.raiseHand",
            },
            isToolbarButtonEnabled("fullscreen", _toolbarButtons) && {
                character: "S",
                exec: this._onShortcutToggleFullScreen,
                helpDescription: "keyboardShortcuts.fullScreen",
            },
            isToolbarButtonEnabled("tileview", _toolbarButtons) && {
                character: "W",
                exec: this._onShortcutToggleTileView,
                helpDescription: "toolbar.tileViewToggle",
            },
            !_isSpeakerStatsDisabled &&
                isToolbarButtonEnabled("stats", _toolbarButtons) && {
                character: "T",
                exec: this._onShortcutSpeakerStats,
                helpDescription: "keyboardShortcuts.showSpeakerStats",
            },
        ];
        KEYBOARD_SHORTCUTS.forEach((shortcut) => {
            if (typeof shortcut === "object") {
                APP.keyboardshortcut.registerShortcut(shortcut.character, null, shortcut.exec, shortcut.helpDescription);
            }
        });
        if (_reactionsEnabled) {
            const REACTION_SHORTCUTS = Object.keys(REACTIONS).map((key) => {
                const onShortcutSendReaction = () => {
                    dispatch(addReactionToBuffer(key));
                    sendAnalytics(createShortcutEvent(`reaction.${key}`));
                };
                return {
                    character: REACTIONS[key].shortcutChar,
                    exec: onShortcutSendReaction,
                    helpDescription: t(`toolbar.reaction${key
                        .charAt(0)
                        .toUpperCase()}${key.slice(1)}`),
                    altKey: true,
                };
            });
            REACTION_SHORTCUTS.forEach((shortcut) => {
                APP.keyboardshortcut.registerShortcut(shortcut.character, null, shortcut.exec, shortcut.helpDescription, shortcut.altKey);
            });
            if (_gifsEnabled) {
                const onGifShortcut = () => {
                    batch(() => {
                        dispatch(toggleReactionsMenuVisibility());
                        dispatch(setGifMenuVisibility(true));
                    });
                };
                APP.keyboardshortcut.registerShortcut("G", null, onGifShortcut, t("keyboardShortcuts.giphyMenu"));
            }
        }
    }
    /**
     * Update the visibility of the {@code OverflowMenuButton}.
     *
     * @inheritdoc
     */
    componentDidUpdate(prevProps) {
        const { _dialog, _visible, dispatch, conferencePar } = this.props;
        let codecParticipant = [];
        const ipRegex = /(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/;
        if (conferencePar) {
            Object.keys(conferencePar).map(function (key, index) {
                var _a;
                if (key === 'remote') {
                    if (((_a = conferencePar[key]) === null || _a === void 0 ? void 0 : _a.size) > 0) {
                        //@ts-ignore
                        [...conferencePar[key].values()].forEach((x) => {
                            if ((x === null || x === void 0 ? void 0 : x.isJigasi) && ipRegex.test(x === null || x === void 0 ? void 0 : x.name))
                                codecParticipant.push(x);
                        });
                    }
                }
            });
        }
        if (prevProps.conferencePar !== this.props.conferencePar &&
            codecParticipant.length > 0) {
            this.setState({
                isShowConnect: false,
            });
        }
        if (prevProps.conferencePar !== this.props.conferencePar &&
            codecParticipant.length === 0) {
            this.setState({
                isShowConnect: true,
            });
        }
        if (prevProps._overflowMenuVisible && !prevProps._dialog && _dialog) {
            this._onSetOverflowVisible(false);
            dispatch(setToolbarHovered(false));
        }
        if (prevProps._hangupMenuVisible && prevProps._visible && !_visible) {
            this._onSetHangupVisible(false);
            dispatch(setToolbarHovered(false));
        }
    }
    /**
     * Removes keyboard shortcuts registered by this component.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        ["A", "C", "D", "R", "S"].forEach((letter) => APP.keyboardshortcut.unregisterShortcut(letter));
        if (this.props._reactionsEnabled) {
            Object.keys(REACTIONS)
                .map((key) => REACTIONS[key].shortcutChar)
                .forEach((letter) => APP.keyboardshortcut.unregisterShortcut(letter, true));
        }
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        if (this.props._disabled) {
            return null;
        }
        const { _chatOpen, _visible, _toolbarButtons } = this.props;
        const rootClassNames = `new-toolbox ${_chatOpen ? "" : "hide-button-600"} new-toolbox-600 hide-button-1200 ${_visible ? "visible" : ""} ${_toolbarButtons.length ? "" : "no-buttons"} ${_chatOpen ? "shift-right" : ""}`;
        return (React.createElement("div", { className: rootClassNames, id: "new-toolbox", onFocus: this._onTabIn, onMouseOut: this._onMouseOut, onMouseOver: this._onMouseOver }, this._renderToolboxContent()));
    }
    /**
     * Key handler for overflow/hangup menus.
     *
     * @param {KeyboardEvent} e - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscKey(e) {
        if ((e === null || e === void 0 ? void 0 : e.key) === "Escape") {
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            this._closeHangupMenuIfOpen();
            this._closeOverflowMenuIfOpen();
        }
    }
    /**
     * Closes the hangup menu if opened.
     *
     * @private
     * @returns {void}
     */
    _closeHangupMenuIfOpen() {
        const { dispatch, _hangupMenuVisible } = this.props;
        _hangupMenuVisible && dispatch(setHangupMenuVisible(false));
    }
    /**
     * Closes the overflow menu if opened.
     *
     * @private
     * @returns {void}
     */
    _closeOverflowMenuIfOpen() {
        const { dispatch, _overflowMenuVisible } = this.props;
        _overflowMenuVisible && dispatch(setOverflowMenuVisible(false));
    }
    /**
     * Dispatches an action to open the video quality dialog.
     *
     * @private
     * @returns {void}
     */
    _doOpenVideoQuality() {
        this.props.dispatch(openDialog(VideoQualityDialog));
    }
    /**
     * Dispatches an action to toggle the display of chat.
     *
     * @private
     * @returns {void}
     */
    _doToggleChat() {
        this.props.dispatch(toggleChat());
    }
    /**
     * Dispatches an action to toggle screensharing.
     *
     * @private
     * @returns {void}
     */
    _doToggleFullScreen() {
        const fullScreen = !this.props._fullScreen;
        this.props.dispatch(setFullScreen(fullScreen));
    }
    /**
     * Dispatches an action to toggle the local participant's raised hand state.
     *
     * @private
     * @returns {void}
     */
    _doToggleRaiseHand() {
        const { _raisedHand } = this.props;
        this.props.dispatch(raiseHand(!_raisedHand));
    }
    /**
     * Dispatches an action to toggle screensharing.
     *
     * @private
     * @param {boolean} enabled - The state to toggle screen sharing to.
     * @param {boolean} audioOnly - Only share system audio.
     * @returns {void}
     */
    _doToggleScreenshare() {
        const { _desktopSharingButtonDisabled, _desktopSharingEnabled, _screenSharing, dispatch, } = this.props;
        if (_desktopSharingEnabled && !_desktopSharingButtonDisabled) {
            dispatch(startScreenShareFlow(!_screenSharing));
        }
    }
    /**
     * Dispatches an action to toggle the video quality dialog.
     *
     * @private
     * @returns {void}
     */
    _doToggleVideoQuality() {
        this.props.dispatch(toggleDialog(VideoQualityDialog));
    }
    /**
     * Dispaches an action to toggle tile view.
     *
     * @private
     * @returns {void}
     */
    _doToggleTileView() {
        this.props.dispatch(toggleTileView());
    }
    /**
     * Returns all buttons that could be rendered.
     *
     * @param {Object} state - The redux state.
     * @returns {Object} The button maps mainMenuButtons and overflowMenuButtons.
     */
    _getAllButtons() {
        const { _feedbackConfigured, _hasSalesforce, _isIosMobile, _isMobile, _isNarrowLayout, _isSpeakerStatsDisabled, _multiStreamModeEnabled, _reactionsEnabled, _screenSharing, _whiteboardEnabled, } = this.props;
        const microphone = {
            key: "microphone",
            Content: AudioSettingsButton,
            group: 0,
        };
        const camera = {
            key: "camera",
            Content: VideoSettingsButton,
            group: 0,
        };
        const profile = this._isProfileVisible() && {
            key: "profile",
            Content: ProfileButton,
            group: 1,
        };
        const chat = {
            key: "chat",
            Content: ChatButton,
            handleClick: this._onToolbarToggleChat,
            group: 2,
        };
        const desktop = this._showDesktopSharingButton() && {
            key: "desktop",
            Content: ShareDesktopButton,
            handleClick: this._onToolbarToggleScreenshare,
            group: 2,
        };
        const raisehand = (!_reactionsEnabled ||
            (!_isNarrowLayout && !_isMobile)) && {
            key: "raisehand",
            Content: ReactionsMenuButton,
            handleClick: this._onToolbarToggleRaiseHand,
            group: 2,
        };
        const participants = {
            key: "participants-pane",
            Content: ParticipantsPaneButton,
            handleClick: this._onToolbarToggleParticipantsPane,
            group: 2,
        };
        const invite = {
            key: "invite",
            Content: InviteButton,
            group: 2,
        };
        const tileview = {
            key: "tileview",
            Content: TileViewButton,
            group: 2,
        };
        const toggleCamera = {
            key: "toggle-camera",
            Content: ToggleCameraButton,
            group: 2,
        };
        const videoQuality = {
            key: "videoquality",
            Content: VideoQualityButton,
            handleClick: this._onToolbarOpenVideoQuality,
            group: 2,
        };
        const fullscreen = !_isIosMobile && {
            key: "fullscreen",
            Content: FullscreenButton,
            handleClick: this._onToolbarToggleFullScreen,
            group: 2,
        };
        const security = {
            key: "security",
            alias: "info",
            Content: SecurityDialogButton,
            group: 2,
        };
        const cc = {
            key: "closedcaptions",
            Content: ClosedCaptionButton,
            group: 2,
        };
        const recording = {
            key: "recording",
            Content: RecordButton,
            group: 2,
        };
        const livestreaming = {
            key: "livestreaming",
            Content: LiveStreamButton,
            group: 2,
        };
        const linkToSalesforce = _hasSalesforce && {
            key: "linktosalesforce",
            Content: LinkToSalesforceButton,
            group: 2,
        };
        const shareVideo = {
            key: "sharedvideo",
            Content: SharedVideoButton,
            group: 3,
        };
        const shareAudio = this._showAudioSharingButton() && {
            key: "shareaudio",
            Content: ShareAudioButton,
            group: 3,
        };
        const noiseSuppression = {
            key: "noisesuppression",
            Content: NoiseSuppressionButton,
            group: 3,
        };
        const whiteboard = _whiteboardEnabled && {
            key: "whiteboard",
            Content: WhiteboardButton,
            group: 3,
        };
        const etherpad = {
            key: "etherpad",
            Content: SharedDocumentButton,
            group: 3,
        };
        const virtualBackground = (_multiStreamModeEnabled ||
            !_screenSharing) && {
            key: "select-background",
            Content: VideoBackgroundButton,
            group: 3,
        };
        const speakerStats = !_isSpeakerStatsDisabled && {
            key: "stats",
            Content: SpeakerStatsButton,
            group: 3,
        };
        const settings = {
            key: "settings",
            Content: SettingsButton,
            group: 4,
        };
        const shortcuts = !_isMobile &&
            keyboardShortcut.getEnabled() && {
            key: "shortcuts",
            Content: KeyboardShortcutsButton,
            group: 4,
        };
        const embed = this._isEmbedMeetingVisible() && {
            key: "embedmeeting",
            Content: EmbedMeetingButton,
            group: 4,
        };
        const feedback = _feedbackConfigured && {
            key: "feedback",
            Content: FeedbackButton,
            group: 4,
        };
        const download = {
            key: "download",
            Content: DownloadButton,
            group: 4,
        };
        const help = {
            key: "help",
            Content: HelpButton,
            group: 4,
        };
        return {
            microphone,
            camera,
            profile,
            desktop,
            chat,
            raisehand,
            participants,
            invite,
            tileview,
            toggleCamera,
            videoQuality,
            fullscreen,
            security,
            cc,
            recording,
            livestreaming,
            linkToSalesforce,
            shareVideo,
            shareAudio,
            noiseSuppression,
            whiteboard,
            etherpad,
            virtualBackground,
            speakerStats,
            settings,
            shortcuts,
            embed,
            feedback,
            download,
            help,
        };
    }
    /**
     * Returns the notify mode of the given toolbox button.
     *
     * @param {string} btnName - The toolbar button's name.
     * @returns {string|undefined} - The button's notify mode.
     */
    _getButtonNotifyMode(btnName) {
        var _a;
        const notify = (_a = this.props._buttonsWithNotifyClick) === null || _a === void 0 ? void 0 : _a.find((btn) => (typeof btn === "string" && btn === btnName) ||
            (typeof btn === "object" && btn.key === btnName));
        if (notify) {
            return typeof notify === "string" || notify.preventExecution
                ? NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY
                : NOTIFY_CLICK_MODE.ONLY_NOTIFY;
        }
    }
    /**
     * Sets the notify click mode for the buttons.
     *
     * @param {Object} buttons - The list of toolbar buttons.
     * @returns {void}
     */
    _setButtonsNotifyClickMode(buttons) {
        var _a;
        if (typeof APP === "undefined" ||
            !((_a = this.props._buttonsWithNotifyClick) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        Object.values(buttons).forEach((button) => {
            if (typeof button === "object") {
                button.notifyMode = this._getButtonNotifyMode(button.key);
            }
        });
    }
    /**
     * Returns all buttons that need to be rendered.
     *
     * @param {Object} state - The redux state.
     * @returns {Object} The visible buttons arrays .
     */
    _getVisibleButtons() {
        const { _clientWidth, _toolbarButtons, _jwtDisabledButons } = this.props;
        const buttons = this._getAllButtons();
        this._setButtonsNotifyClickMode(buttons);
        const isHangupVisible = isToolbarButtonEnabled("hangup", _toolbarButtons);
        const { order } = THRESHOLDS.find(({ width }) => _clientWidth > width) ||
            THRESHOLDS[THRESHOLDS.length - 1];
        let sliceIndex = order.length + 2;
        const keys = Object.keys(buttons);
        const filtered = [
            ...order.map((key) => buttons[key]),
            ...Object.values(buttons).filter((button, index) => !order.includes(keys[index])),
        ]
            .filter(Boolean)
            .filter(({ key, alias = NOT_APPLICABLE }) => !_jwtDisabledButons.includes(key) &&
            (isToolbarButtonEnabled(key, _toolbarButtons) ||
                isToolbarButtonEnabled(alias, _toolbarButtons)));
        if (isHangupVisible) {
            sliceIndex -= 1;
        }
        // This implies that the overflow button will be displayed, so save some space for it.
        if (sliceIndex < filtered.length) {
            sliceIndex -= 1;
        }
        return {
            mainMenuButtons: filtered.slice(0, sliceIndex),
            overflowMenuButtons: filtered.slice(sliceIndex),
        };
    }
    /**
     * Dispatches an action signaling the toolbar is not being hovered.
     *
     * @private
     * @returns {void}
     */
    _onMouseOut() {
        const { _overflowMenuVisible, dispatch } = this.props;
        !_overflowMenuVisible && dispatch(setToolbarHovered(false));
    }
    /**
     * Dispatches an action signaling the toolbar is being hovered.
     *
     * @private
     * @returns {void}
     */
    _onMouseOver() {
        this.props.dispatch(setToolbarHovered(true));
    }
    /**
     * Sets the visibility of the hangup menu.
     *
     * @param {boolean} visible - Whether or not the hangup menu should be
     * displayed.
     * @private
     * @returns {void}
     */
    _onSetHangupVisible(visible) {
        this.props.dispatch(setHangupMenuVisible(visible));
        this.props.dispatch(setToolbarHovered(visible));
    }
    /**
     * Sets the visibility of the overflow menu.
     *
     * @param {boolean} visible - Whether or not the overflow menu should be
     * displayed.
     * @private
     * @returns {void}
     */
    _onSetOverflowVisible(visible) {
        this.props.dispatch(setOverflowMenuVisible(visible));
        this.props.dispatch(setToolbarHovered(visible));
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling the display of chat.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleChat() {
        var _a;
        sendAnalytics(createShortcutEvent("toggle.chat", ACTION_SHORTCUT_TRIGGERED, {
            enable: !this.props._chatOpen,
        }));
        // Checks if there was any text selected by the user.
        // Used for when we press simultaneously keys for copying
        // text messages from the chat board
        if (((_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString()) !== "") {
            return false;
        }
        this._doToggleChat();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling the display of the participants pane.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleParticipantsPane() {
        sendAnalytics(createShortcutEvent("toggle.participants-pane", ACTION_SHORTCUT_TRIGGERED, {
            enable: !this.props._participantsPaneOpen,
        }));
        this._onToolbarToggleParticipantsPane();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling the display of Video Quality.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleVideoQuality() {
        sendAnalytics(createShortcutEvent("video.quality"));
        this._doToggleVideoQuality();
    }
    /**
     * Dispatches an action for toggling the tile view.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleTileView() {
        sendAnalytics(createShortcutEvent("toggle.tileview", ACTION_SHORTCUT_TRIGGERED, {
            enable: !this.props._tileViewEnabled,
        }));
        this._doToggleTileView();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling full screen mode.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleFullScreen() {
        sendAnalytics(createShortcutEvent("toggle.fullscreen", ACTION_SHORTCUT_TRIGGERED, {
            enable: !this.props._fullScreen,
        }));
        this._doToggleFullScreen();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling raise hand.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleRaiseHand() {
        sendAnalytics(createShortcutEvent("toggle.raise.hand", ACTION_SHORTCUT_TRIGGERED, { enable: !this.props._raisedHand }));
        this._doToggleRaiseHand();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling screensharing.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleScreenshare() {
        // Ignore the shortcut if the button is disabled.
        if (this.props._desktopSharingButtonDisabled) {
            return;
        }
        sendAnalytics(createShortcutEvent("toggle.screen.sharing", ACTION_SHORTCUT_TRIGGERED, {
            enable: !this.props._screenSharing,
        }));
        this._doToggleScreenshare();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling speaker stats.
     *
     * @private
     * @returns {void}
     */
    _onShortcutSpeakerStats() {
        sendAnalytics(createShortcutEvent("speaker.stats"));
        this._doToggleSpekearStats();
    }
    /**
     * Dispatches an action to toggle speakerStats.
     *
     * @private
     * @returns {void}
     */
    _doToggleSpekearStats() {
        const { dispatch } = this.props;
        dispatch(toggleDialog(SpeakerStats, {
            conference: APP.conference,
        }));
    }
    /**
     * Toggle the toolbar visibility when tabbing into it.
     *
     * @returns {void}
     */
    _onTabIn() {
        if (!this.props._visible) {
            this.props.dispatch(showToolbox());
        }
    }
    /**
     * Dispatches an action for toggling the participants pane.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleParticipantsPane() {
        const { dispatch, _participantsPaneOpen } = this.props;
        if (_participantsPaneOpen) {
            dispatch(closeParticipantsPane());
        }
        else {
            dispatch(openParticipantsPane());
        }
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for opening
     * the modal for inviting people directly into the conference.
     *
     * @private
     * @returns {void}
     */
    _onToolbarOpenInvite() {
        var _a, _b, _c, _d;
        sendAnalytics(createToolbarEvent("invite"));
        jitsiLocalStorage.setItem("localDemoUser", (_a = this.props.localParticipant) === null || _a === void 0 ? void 0 : _a.email);
        if (((_b = this.props.localParticipant) === null || _b === void 0 ? void 0 : _b.email) ===
            "miruna.caramangiu@gmail.com" ||
            ((_c = this.props.localParticipant) === null || _c === void 0 ? void 0 : _c.email) ===
                "knowhow@innovationsapplied.com") {
            // shard=1 account=miruna duration=30 type=hd
            this.props.dispatch(beginCallPrompt("BEGIN_CALL_PROMPT", (_d = this.props.localParticipant) === null || _d === void 0 ? void 0 : _d.email));
        }
        else {
            this.props.dispatch(beginAddPeople("", false, true, false));
        }
    }
    _onOpenConnectCodec() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("enter open connect");
            this.setState({
                isShowConnect: false,
                isLoading: true,
            });
            //console.log("xxx state isshow ", this.state.isShowConnect)
            //console.log("xxx state isload ", this.state.isLoading)
            sendAnalytics(createToolbarEvent("connect-codec"));
            //console.log("xxx after send anaylitcs ")
            const user = this.props.user;
            //console.log("xxx user ", user)
            let codec;
            try {
                //console.log("xxx try ")
                // @ts-ignore
                const { data } = yield moderatorService.getConfiguration();
                //console.log("xxx data getcodecinfo ", data)
                codec = data.configuration;
                const invitees = [
                    {
                        allowed: true,
                        country: "",
                        number: `${codec === null || codec === void 0 ? void 0 : codec.codec_ip}`,
                        originalEntry: `${codec === null || codec === void 0 ? void 0 : codec.codec_ip}`,
                        showCountryCodeReminder: false,
                        type: "phone",
                        codecName: `${codec === null || codec === void 0 ? void 0 : codec.codec_name}`,
                        roomCode: this.props.room,
                        name: `${codec === null || codec === void 0 ? void 0 : codec.codec_name}`,
                    },
                ];
                // @ts-ignore
                const jitsiInvitees = {
                    filterValues: [`${codec.codec_ip}`, `${codec === null || codec === void 0 ? void 0 : codec.codec_ip}`],
                    content: `${codec === null || codec === void 0 ? void 0 : codec.codec_ip}`,
                    description: "",
                    isDisabled: false,
                    address: "",
                    item: invitees[0],
                    value: `${codec === null || codec === void 0 ? void 0 : codec.codec_ip}`,
                };
                jitsiLocalStorage.setItem("inviteItems", JSON.stringify(jitsiInvitees));
                this.props
                    .dispatch(invite(invitees))
                    .then((invitesLeftToSend) => {
                    var _a, _b, _c, _d;
                    // If any invites are left that means something failed to send
                    // so treat it as an error.
                    if (invitesLeftToSend.length) {
                        const erroredInviteTypeCounts = getInviteTypeCounts(invitesLeftToSend);
                        /*                             logger.error(`${invitesLeftToSend.length} invites failed`,
                                                        erroredInviteTypeCounts); */
                        sendAnalytics(createInviteDialogEvent("error", "invite", Object.assign({}, erroredInviteTypeCounts)));
                    }
                    else if (!this.props._callFlowsEnabled) {
                        const invitedCount = invitees.length;
                        let notificationProps;
                        if (invitedCount >= 3) {
                            notificationProps = {
                                titleArguments: {
                                    name: (_a = invitees[0]) === null || _a === void 0 ? void 0 : _a.name,
                                    count: invitedCount - 1,
                                },
                                titleKey: "notify.invitedThreePlusMembers",
                            };
                        }
                        else if (invitedCount === 2) {
                            notificationProps = {
                                titleArguments: {
                                    first: (_b = invitees[0]) === null || _b === void 0 ? void 0 : _b.name,
                                    second: (_c = invitees[1]) === null || _c === void 0 ? void 0 : _c.name,
                                },
                                titleKey: "notify.invitedTwoMembers",
                            };
                        }
                        else if (invitedCount) {
                            notificationProps = {
                                titleArguments: {
                                    name: (_d = invitees[0]) === null || _d === void 0 ? void 0 : _d.name,
                                },
                                titleKey: "notify.invitedOneMember",
                            };
                        }
                        if (notificationProps) {
                            this.props.dispatch(showNotification(notificationProps, NOTIFICATION_TIMEOUT));
                        }
                    }
                    // return invitesLeftToSend;
                })
                    .finally(() => {
                    this.setState({
                        isLoading: false,
                        isShowConnect: true
                    });
                });
            }
            catch (e) {
                console.log("error", e);
                this.setState({
                    isShowConnect: true,
                });
                this.props.dispatch(openDialog(AlertDialog, {
                    contentKey: {
                        key: "dialog.failToConnectCodec",
                    },
                }));
            }
            // this.props.dispatch(beginAddPeople('', true, false, false));
        });
    }
    _onDisconnectCodec(codecId, isCodecPar) {
        if (!isCodecPar) {
            return;
        }
        this.props.dispatch(kickParticipant(codecId));
        this.setState({
            isShowConnect: true,
        });
    }
    openAudioSetting() {
        this.props.dispatch(toggleAudioSettings());
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * open the video quality dialog.
     *
     * @private
     * @returns {void}
     */
    _onToolbarOpenVideoQuality() {
        sendAnalytics(createToolbarEvent("video.quality"));
        this._doOpenVideoQuality();
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * the display of chat.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleChat() {
        sendAnalytics(createToolbarEvent("toggle.chat", {
            enable: !this.props._chatOpen,
        }));
        this._closeOverflowMenuIfOpen();
        this._doToggleChat();
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * full screen mode.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleFullScreen() {
        sendAnalytics(createToolbarEvent("toggle.fullscreen", {
            enable: !this.props._fullScreen,
        }));
        this._closeOverflowMenuIfOpen();
        this._doToggleFullScreen();
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * raise hand.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleRaiseHand() {
        sendAnalytics(createToolbarEvent("raise.hand", {
            enable: !this.props._raisedHand,
        }));
        this._doToggleRaiseHand();
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * screensharing.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleScreenshare() {
        sendAnalytics(createToolbarEvent("toggle.screen.sharing", {
            enable: !this.props._screenSharing,
        }));
        this._closeOverflowMenuIfOpen();
        this._doToggleScreenshare();
    }
    /**
     * Returns true if the audio sharing button should be visible and
     * false otherwise.
     *
     * @returns {boolean}
     */
    _showAudioSharingButton() {
        const { _desktopSharingEnabled } = this.props;
        return _desktopSharingEnabled && isScreenAudioSupported();
    }
    /**
     * Returns true if the desktop sharing button should be visible and
     * false otherwise.
     *
     * @returns {boolean}
     */
    _showDesktopSharingButton() {
        return this.props._desktopSharingEnabled;
    }
    /**
     * Returns true if the embed meeting button is visible and false otherwise.
     *
     * @returns {boolean}
     */
    _isEmbedMeetingVisible() {
        return !this.props._isVpaasMeeting && !this.props._isMobile;
    }
    /**
     * Returns true if the profile button is visible and false otherwise.
     *
     * @returns {boolean}
     */
    _isProfileVisible() {
        return !this.props._isProfileDisabled;
    }
    /**
     * Returns the buttons to be displayed in main or the overflow menu.
     *
     * @param {Set} buttons - A set containing the buttons to be displayed
     * in the toolbar beside the main audio/video & hanugup.
     * @returns {Object}
     */
    _getAdditionalButtons(buttons) {
        var _a;
        const { _chatOpen, _desktopSharingEnabled, _desktopSharingDisabledTooltipKey, _raisedHand, _screensharing, t, user, conferencePar, isModerator: _isModerator, settingMode } = this.props;
        // console.log("xxx this props ", this.props)
        //const codecParticipant = this.props.conferencePar.length > 0 ? this.props.conferencePar.filter((con: { isJigasi: any; }) => con.isJigasi) : this.props.conferencePar;
        let participants = []; //this.props.conferencePar.length > 0 ? this.props.conferencePar.filter((data: { isJigasi: any; }) => !data.isJigasi) : this.props.conferencePar;
        let codecParticipant = []; // this.props.conferencePar.length > 0 ? this.props.conferencePar.filter((con: { isJigasi: any; }) => con.isJigasi) : this.props.conferencePar;
        // participants == remote participants who are NOT isJigasi
        //    map remote participants where conf par len > 0
        //    return all participants where !isJagasi
        // codecParticipant == remote participants who ARE isJagasi
        //    map remote participants where conf par len > 0
        //    return all participants where isJagsi
        Object.keys(conferencePar).map(function (key, index) {
            var _a;
            if (key === 'remote') {
                // onsole.log("xxx key: ",key);
                //@ts-ignore
                // console.log("xxx remote key: ",conferencePar[key]);
                //@ts-ignore
                // console.log("xxx remote key size: ",conferencePar[key]?.size);
                //@ts-ignore
                if (((_a = conferencePar[key]) === null || _a === void 0 ? void 0 : _a.size) > 0) {
                    //@ts-ignore
                    [...conferencePar[key].values()].forEach((x) => {
                        // console.log("xxx remote values spread.from: ", x);
                        //@ts-ignore
                        // console.log("xxx remote value jigasi spread.from: ", x?.isJigasi);
                        //@ts-ignore
                        (x === null || x === void 0 ? void 0 : x.isJigasi)
                            ? codecParticipant.push(x)
                            : participants.push(x);
                    });
                }
            }
        });
        // console.log("xxx participants: ",participants);
        // console.log("xxx codecs: ",codecParticipant);
        const codecId = (_a = codecParticipant[0]) === null || _a === void 0 ? void 0 : _a.id;
        const overflowMenuAdditionalButtons = [];
        const isCodecPar = Boolean(codecParticipant.length);
        // console.log("xxx iscodecpar: ", isCodecPar);
        const mainMenuAdditionalButtons = [];
        const { _toolbarButtons } = this.props;
        if (_isModerator && isToolbarButtonEnabled("invite", _toolbarButtons)) {
            buttons.has("invite")
                ? mainMenuAdditionalButtons.push(React.createElement(ToolbarButton, { accessibilityLabel: t("toolbar.accessibilityLabel.invite"), className: "hide-button-900 hide-icon-900 hide-icon-invite", noInvite: participants.length > 4, hiddenIcon: false, icon: IconInviteMore, key: "invitewoi", showCustom: true, label: t("toolbar.label.invite"), onClick: this._onToolbarOpenInvite, tooltip: t("toolbar.invite") }))
                : overflowMenuAdditionalButtons.push(React.createElement(OverflowMenuItem, { accessibilityLabel: t("toolbar.accessibilityLabel.invite "), icon: IconInviteMore, key: "invite", onClick: this._onToolbarOpenInvite, text: t("toolbar.invite") }));
        }
        if (_isModerator && isToolbarButtonEnabled("invite", _toolbarButtons)) {
            buttons.has("invite")
                ? mainMenuAdditionalButtons.push(React.createElement(ToolbarButton, { accessibilityLabel: t("toolbar.accessibilityLabel.invite"), className: "hide-button-900 hide-icon-900 show-icon-invite", noInvite: participants.length > 4, hiddenIcon: true, icon: IconInviteMore, key: "invite", showCustom: true, label: t("toolbar.label.invite"), onClick: this._onToolbarOpenInvite, tooltip: t("toolbar.invite") }))
                : overflowMenuAdditionalButtons.push(React.createElement(OverflowMenuItem, { accessibilityLabel: t("toolbar.accessibilityLabel.invite"), icon: IconInviteMore, key: "invite", onClick: this._onToolbarOpenInvite, text: t("toolbar.invite") }));
        }
        if (isToolbarButtonEnabled("connect-codec", _toolbarButtons) &&
            _isModerator &&
            this.state.isShowConnect) {
            buttons.has("connect-codec")
                ? mainMenuAdditionalButtons.push(React.createElement(ToolbarButton, { accessibilityLabel: t("toolbar.accessibilityLabel.connect"), icon: IconConnect, className: `background-theme-2 hide-button-900 hide-icon-1024`, key: "connect", showCustom: true, disabled: this.props.settingMode === "silent" &&
                        participants.length < 1, label: t("toolbar.label.connect"), tooltip: t("toolbar.label.connect"), onClick: this._onOpenConnectCodec }))
                : overflowMenuAdditionalButtons.push(React.createElement(OverflowMenuItem, { accessibilityLabel: t("toolbar.accessibilityLabel.connect"), icon: IconConnect, key: "connect", disabled: this.props.settingMode === "silent" &&
                        participants.length < 1, onClick: this.state.isLoading
                        ? undefined
                        : this._onOpenConnectCodec, text: t("toolbar.label.connect") }));
        }
        if (isToolbarButtonEnabled("connect-codec", _toolbarButtons) &&
            _isModerator &&
            !this.state.isShowConnect) {
            buttons.has("connect-codec")
                ? mainMenuAdditionalButtons.push(React.createElement(ToolbarButton, { accessibilityLabel: t("toolbar.accessibilityLabel.disconnect"), icon: IconConnect, disabled: true, className: `background-theme-2 hide-button-900 hide-icon-1024`, key: "disconnect", showCustom: true, label: t("toolbar.label.disconnect"), tooltip: t("toolbar.label.disconnect"), onClick: isCodecPar
                        ? () => this._onDisconnectCodec(codecId, isCodecPar)
                        : undefined }))
                : overflowMenuAdditionalButtons.push(React.createElement(OverflowMenuItem, { accessibilityLabel: t("toolbar.accessibilityLabel.disconnect"), icon: IconConnect, disabled: true, key: "disconnect", onClick: isCodecPar
                        ? () => this._onDisconnectCodec(codecId, isCodecPar)
                        : undefined, text: t("toolbar.label.disconnect") }));
        }
        mainMenuAdditionalButtons.push(this._renderAudioButton());
        if (isToolbarButtonEnabled("audio-setting", _toolbarButtons)) {
            buttons.has("audio-setting")
                ? mainMenuAdditionalButtons.push(React.createElement("div", { className: "toolbar-button-with-badge", key: "audiosetting" },
                    React.createElement(AudioSettingsPopup, null,
                        React.createElement(ToolbarButton, { accessibilityLabel: t("toolbar.accessibilityLabel.audio-setting"), key: "audio-setting", icon: IconAudio, showCustom: true, className: "background-theme-2 hide-button-900 hide-icon-900", onClick: this.openAudioSetting, label: t("toolbar.label.audioSettings"), tooltip: t("toolbar.audioSettings") }))))
                : overflowMenuAdditionalButtons.push(React.createElement(OverflowMenuItem, { accessibilityLabel: t("toolbar.accessibilityLabel.audio-setting"), onClick: this.openAudioSetting, icon: IconAudio, key: "audio-setting", text: t("toolbar.label.audioSettings") }));
        }
        // if (this._showDesktopSharingButton()) {
        //     buttons.has('desktop')
        //         ? mainMenuAdditionalButtons.push(<ToolbarButton
        //             accessibilityLabel = { t('toolbar.accessibilityLabel.shareYourScreen') }
        //             disabled = { !_desktopSharingEnabled }
        //             icon = { IconShareDesktop }
        //             key = 'desktop'
        //             onClick = { this._onToolbarToggleScreenshare }
        //             toggled = { _screensharing }
        //             tooltip = { t(_desktopSharingEnabled
        //                 ? 'dialog.shareYourScreen' : _desktopSharingDisabledTooltipKey) } />)
        //         : overflowMenuAdditionalButtons.push(<OverflowMenuItem
        //             accessibilityLabel = { t('toolbar.accessibilityLabel.shareYourScreen') }
        //             icon = { IconShareDesktop }
        //             iconId = 'share-desktop'
        //             key = 'desktop'
        //             onClick = { this._onToolbarToggleScreenshare }
        //             text = { t(`toolbar.${_screensharing ? 'stopScreenSharing' : 'startScreenSharing'}`) } />);
        // }
        if (isToolbarButtonEnabled("chat", _toolbarButtons)) {
            buttons.has("chat")
                ? mainMenuAdditionalButtons.push(React.createElement("div", { className: "toolbar-button-with-badge", key: "chatcontainer" },
                    React.createElement(ToolbarButton, { accessibilityLabel: t("toolbar.accessibilityLabel.chat"), icon: IconChat, key: "chat", showCustom: true, className: "background-theme-2 hide-button-900 hide-icon-900", label: t("toolbar.label.chat"), onClick: this._onToolbarToggleChat, toggled: _chatOpen, tooltip: t("toolbar.chat") }),
                    React.createElement(ChatCounter, null)))
                : overflowMenuAdditionalButtons.push(React.createElement(OverflowMenuItem, { accessibilityLabel: t("toolbar.accessibilityLabel.chat"), icon: IconChat, key: "chat", onClick: this._onToolbarToggleChat, text: t(`toolbar.${_chatOpen ? "closeChat" : "openChat"}`) }));
        }
        if (isToolbarButtonEnabled("stats", _toolbarButtons)) {
            buttons.has("stats")
                ? mainMenuAdditionalButtons.push(React.createElement(ToolbarButton, { accessibilityLabel: t("toolbar.accessibilityLabel.speakerStats"), icon: IconPresentation, key: "stats", showCustom: true, className: `background-theme-2 hide-button-900 hide-icon-900 ${_chatOpen ? "hide-icon-1024" : ""}`, label: t("toolbar.speakerStats"), onClick: this._onShortcutSpeakerStats, tooltip: t("toolbar.speakerStats") }))
                : overflowMenuAdditionalButtons.push(React.createElement(OverflowMenuItem, { accessibilityLabel: t("toolbar.accessibilityLabel.speakerStats"), icon: IconPresentation, key: "stats", onClick: this._onShortcutSpeakerStats, text: t("toolbar.speakerStats") }));
        }
        // if (this._shouldShowButton('audio-setting')) {
        //     buttons.has('audio-setting')
        //         ? mainMenuAdditionalButtons.push(
        //             <ToolbarButton
        //                 accessibilityLabel = { t('toolbar.accessibilityLabel.connect') }
        //                 className = { 'background-theme-2 hide-button-900 hide-icon-900' }
        //                 icon = { IconAudio }
        //                 key = 'audio-setting'
        //                 label = { t('toolbar.audioSetting') }
        //                 tooltip = { t('toolbar.audioSetting') }
        //             />)
        //         : overflowMenuAdditionalButtons.push(
        //             <OverflowMenuItem
        //                 accessibilityLabel = { t('toolbar.accessibilityLabel.connect') }
        //                 icon = { IconAudio }
        //                 key = 'audio-setting'
        //                 text = { t('toolbar.label.connect') } />
        //         );
        // }
        if (isToolbarButtonEnabled("raisehand", _toolbarButtons)) {
            buttons.has("raisehand")
                ? mainMenuAdditionalButtons.push(React.createElement(ToolbarButton, { accessibilityLabel: t("toolbar.accessibilityLabel.raiseHand"), className: "toolbox-disabled background-theme-2", icon: IconRaisedHand, key: "raisehand", showCustom: true, arrow: true, disabled: this.props.settingMode === "silent" &&
                        _isModerator, onClick: this._onToolbarToggleRaiseHand, toggled: _raisedHand, tooltip: t(`toolbar.${_raisedHand
                        ? "lowerYourHand"
                        : "raiseYourHand"}`) }))
                : overflowMenuAdditionalButtons.push(React.createElement(OverflowMenuItem, { accessibilityLabel: t("toolbar.accessibilityLabel.raiseHand"), icon: IconRaisedHand, key: "raisehand", onClick: this._onToolbarToggleRaiseHand, text: t(`toolbar.${_raisedHand
                        ? "lowerYourHand"
                        : "raiseYourHand"}`) }));
        }
        // if (this._shouldShowButton('tileview')) {
        //     buttons.has('tileview')
        //         ? mainMenuAdditionalButtons.push(
        //             <TileViewButton
        //                 key = 'tileview'
        //                 showLabel = { false } />)
        //         : overflowMenuAdditionalButtons.push(
        //             <TileViewButton
        //                 key = 'tileview'
        //                 showLabel = { true } />);
        // }
        return {
            mainMenuAdditionalButtons,
            overflowMenuAdditionalButtons,
        };
    }
    /**
     * Renders the Audio controlling button.
     *
     * @returns {ReactElement}
     */
    _renderAudioButton() {
        const { _toolbarButtons } = this.props;
        return isToolbarButtonEnabled("microphone", _toolbarButtons) ? (React.createElement(AudioSettingsButton, { key: "asb", showCustom: true, isShowPopup: false, visible: false })) : null;
    }
    /**
     * Renders the Video controlling button.
     *
     * @returns {ReactElement}
     */
    _renderVideoButton() {
        const { _toolbarButtons } = this.props;
        return isToolbarButtonEnabled("camera", _toolbarButtons) ? (React.createElement(VideoSettingsButton, { key: "vsb", showCustom: true, visible: true })) : null;
    }
    /**
     * Renders the toolbox content.
     *
     * @returns {ReactElement}
     */
    _renderToolboxContent() {
        const { _clientWidth, _endConferenceSupported, _hangupMenuVisible, _isMobile, _isNarrowLayout, _overflowDrawer, _overflowMenuVisible, _reactionsEnabled, _toolbarButtons, classes, isModerator: _isModerator, t, } = this.props;
        const buttonSet = getToolbarAdditionalButtons(_clientWidth, _isMobile);
        const toolbarAccLabel = "toolbar.accessibilityLabel.moreActionsMenu";
        const containerClassName = `toolbox-content${_isMobile || _isNarrowLayout ? " toolbox-content-mobile" : ""} ${_isModerator ? "" : "toolbox-content-flex-end"}`;
        // const { mainMenuButtons, overflowMenuButtons } = this._getVisibleButtons();
        const { mainMenuAdditionalButtons } = this._getAdditionalButtons(buttonSet);
        return (React.createElement("div", { className: containerClassName },
            React.createElement("div", { className: "toolbox-content-wrapper" },
                React.createElement("div", { className: "toolbox-content-items flex-row flex-wrap-toolbox hang-up-500" },
                    mainMenuAdditionalButtons,
                    React.createElement(HangupButton, { buttonKey: "hangup", customClass: "hangup-button", key: "hangup-button", showCustom: true, notifyMode: this._getButtonNotifyMode("hangup"), visible: isToolbarButtonEnabled("hangup", _toolbarButtons) })))));
    }
}
/**
 * Maps (parts of) the redux state to {@link Toolbox}'s React {@code Component}
 * props.
 *
 * @param {Object} state - The redux store/state.
 * @param {Object} ownProps - The props explicitly passed.
 * @private
 * @returns {{}}
 */
function _mapStateToProps(state, ownProps) {
    var _a;
    const { conference } = state["features/base/conference"];
    const { isNarrowLayout } = state["features/base/responsive-ui"];
    const endConferenceSupported = conference === null || conference === void 0 ? void 0 : conference.isEndConferenceSupported();
    const { buttonsWithNotifyClick, callStatsID, disableProfile, iAmRecorder, iAmSipGateway, } = state["features/base/config"];
    const { fullScreen, hangupMenuVisible, overflowMenuVisible, overflowDrawer, } = state["features/toolbox"];
    const localParticipant = getLocalParticipant(state);
    const isModerator = ((_a = getLocalParticipant(state)) === null || _a === void 0 ? void 0 : _a.role) === PARTICIPANT_ROLE.MODERATOR;
    const conferencePar = state["features/base/participants"];
    // @ts-nocheck
    const user = JSON.parse(jitsiLocalStorage.getItem("features/base/settings")).user;
    const localVideo = getLocalVideoTrack(state["features/base/tracks"]);
    const { clientWidth } = state["features/base/responsive-ui"];
    const toolbarButtons = ownProps.toolbarButtons || getToolbarButtons(state);
    const room = state["features/base/conference"].room;
    const setting = state["features/settings"].audioSettingsVisible;
    // @ts-nocheck
    const settingMode = JSON.parse(jitsiLocalStorage.getItem("features/base/settings")).mode;
    return {
        _backgroundType: state["features/virtual-background"].backgroundType,
        _buttonsWithNotifyClick: buttonsWithNotifyClick,
        _chatOpen: state["features/chat"].isOpen,
        _clientWidth: clientWidth,
        _conference: conference,
        _desktopSharingEnabled: JitsiMeetJS.isDesktopSharingEnabled(),
        _desktopSharingButtonDisabled: isDesktopShareButtonDisabled(state),
        _dialog: Boolean(state["features/base/dialog"].component),
        _disabled: Boolean(iAmRecorder || iAmSipGateway),
        _endConferenceSupported: Boolean(endConferenceSupported),
        _feedbackConfigured: Boolean(callStatsID),
        _fullScreen: fullScreen,
        _gifsEnabled: isGifEnabled(state),
        _isProfileDisabled: Boolean(disableProfile),
        _isIosMobile: isIosMobileBrowser(),
        _isMobile: isMobileBrowser(),
        _isSpeakerStatsDisabled: isSpeakerStatsDisabled(state),
        _isVpaasMeeting: isVpaasMeeting(state),
        _jwtDisabledButons: getJwtDisabledButtons(state),
        _hasSalesforce: isSalesforceEnabled(state),
        _hangupMenuVisible: hangupMenuVisible,
        _isNarrowLayout: isNarrowLayout,
        _localParticipantID: localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.id,
        _localVideo: localVideo,
        _multiStreamModeEnabled: getMultipleVideoSendingSupportFeatureFlag(state),
        _overflowMenuVisible: overflowMenuVisible,
        _overflowDrawer: overflowDrawer,
        _participantsPaneOpen: getParticipantsPaneOpen(state),
        _raisedHand: hasRaisedHand(localParticipant),
        _reactionsEnabled: isReactionsEnabled(state),
        _screenSharing: isScreenVideoShared(state),
        _tileViewEnabled: shouldDisplayTileView(state),
        _toolbarButtons: toolbarButtons,
        _virtualSource: state["features/virtual-background"].virtualSource,
        _visible: isToolboxVisible(state),
        conferencePar,
        setting,
        user,
        room,
        settingMode,
        isModerator,
        _whiteboardEnabled: isWhiteboardButtonVisible(state),
        localParticipant,
    };
}
export default translate(connect(_mapStateToProps)(withStyles(styles)(Toolbox)));
